class APIS {
	apis() {
		return {
			create: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/dynamic-banner/create'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/dynamic-banner/update'
			},
			toggle: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/dynamic-banner/toggle'
			},
			fetch: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/dynamic-banner/fetch'
			},
			active: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/dynamic-banner/active'
			}
		};
	}
}

export default new APIS();
